import styled, { css } from 'styled-components';
import { AppLogo } from '../../pages/home/MobileApp/styles';

export const Container = styled.div`
    text-align: center;
    ${p => p.theme.xs(css`
        margin-top: 32px;
    `)}

    h2 {
        margin-bottom: 16px;
    }
`;

export const AppLogoExt = styled(AppLogo)`
    width: 80px;
    height: 80px;
    border-radius: 16px;
`;